// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"72":"2cf99be7","280":"d5c28fbc","667":"cbd265aa"}[chunkId] + ".chunk.css");